<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar logo="logos/logo_primary.png">
      <template slot-scope="props" slot="links">
        <!--
        <sidebar-item
          :link="{
            name: 'Dashboards',
            icon: 'ni ni-shop text-primary',
          }"
        >
          <sidebar-item
            :link="{ name: 'Dashboard', path: '/dashboard' }"
          ></sidebar-item>
          <sidebar-item
            :link="{ name: 'Alternative', path: '/alternative' }"
          ></sidebar-item>
        </sidebar-item>
        -->
        <sidebar-item v-if="$can('show management', 'materias')"
          :link="{
            name: 'Materias',
            icon: 'ni ni-umbrella-13',
            path: '/materias'
          }">
        </sidebar-item>

        <sidebar-item
          :link="{
            name: 'Venta de Planes',
            icon: 'ni ni ni-basket text-green'
          }">
              <sidebar-item :link="{
                name: 'Panel Ventas',
                path: '/ventas/'
              }">
              </sidebar-item>
              <sidebar-item :link="{
                name: 'Nueva Venta',
                path: '/ventas/crear'
              }">
              </sidebar-item>
              <sidebar-item v-if="$can('show nueva venta gmo peru', 'ventas')" :link="{
                name: 'Nueva Venta GMO Perú',
                path: '/ventas/gmo-peru' 
              }">
              </sidebar-item>
        </sidebar-item>
        <sidebar-item
        
          :link="{
            name: 'Planes',
            icon: 'ni ni-paper-diploma text-orange'
          }">
              <sidebar-item v-if="$can('show management', 'planes')" :link="{
                name: 'Gestionar Planes',
                path: '/planes/'
              }">
              </sidebar-item>
              <sidebar-item v-if="$can('show management', 'categorias')" :link="{
                name: 'Gestionar Categorias',
                path: '/planes/categorias/'
              }">
              </sidebar-item>
              <sidebar-item v-if="$can('show management', 'subcategorias')" :link="{
                name: 'Gestionar Subcategorias',
                path: '/planes/subcategorias/'
              }">
              </sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Administración Sistema',
            icon: 'ni ni-key-25 text-blue'
          }">
              <sidebar-item v-if="$can('show management', 'users')" :link="{
                name: 'Gestionar Usuarios',
                path: '/admin/usuarios'
              }">
              </sidebar-item>
              <sidebar-item v-if="$can('show management', 'equipos')" :link="{
                name: 'Gestionar Equipos',
                path: '/admin/equipos'
              }">
              </sidebar-item>
              <sidebar-item v-if="$can('show management', 'sucursales')" :link="{
                name: 'Gestionar Sucursales',
                path: '/admin/sucursales'
              }">
              </sidebar-item>
              <sidebar-item v-if="$can('show management', 'sponsors')" :link="{
                name: 'Gestionar Sponsors',
                path: '/admin/sponsors'
              }">
              </sidebar-item>
        </sidebar-item>
        
        <sidebar-item v-if="$can('show management', 'siniestros')"
          :link="{
            name: 'Siniestros',
            icon: 'fas fa-fire-extinguisher text-red'
          }">
              <sidebar-item  :link="{
                name: 'Gestionar siniestros',
                path: '/siniestros/ingresar'
              }">
              </sidebar-item>
        </sidebar-item>
        <sidebar-item
          :link="{
            name: 'Reportes',
            icon: 'fas fa-file-contract text-brown'
          }">
              <sidebar-item v-if="$can('show siniestro', 'reportes')" :link="{
                name: 'Reportes Siniestros',
                path: '/reportes/siniestros'
              }">
              </sidebar-item>
              <sidebar-item v-if="$can('show sponsor', 'reportes')" :link="{
                name: 'Reportes Sponsor',
                path: '/reportes/sponsor'
              }">
              </sidebar-item>
              <sidebar-item v-if="$can('show company', 'reportes')" :link="{
                name: 'Reportes por Compañía',
                path: '/reportes/compañia'
              }">
              </sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="$can('show list', 'garantias')"
          :link="{
            name: 'Garantias',
            icon: 'ni ni-tag text-blue',
            path: '/garantias'
          }">
        </sidebar-item>
        <sidebar-item v-if="$can('show activity', 'logs')"
          :link="{
            name: 'Registro de Actividad',
            icon: 'ni ni-sound-wave text-yellow',
            path: '/actividad'
          }">
        </sidebar-item>
      </template>
      <!--
      <template slot="links-after">
        <hr class="my-3">
        <h6 class="navbar-heading p-0 text-muted">Documentation</h6>

        <ul class="navbar-nav mb-md-3">
          <li class="nav-item">
            <a class="nav-link" href="https://demos.creative-tim.com/vue-argon-dashboard-pro/documentation"
               target="_blank">
              <i class="ni ni-spaceship"></i>
              <span class="nav-link-text">Getting started</span>
            </a>
          </li>
          
        </ul>
      </template>
      -->
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
    <google-spin v-show="$store.state.loadingStack"></google-spin>
  </div>
</template>
<script>
  /* eslint-disable no-new */
  import PerfectScrollbar from 'perfect-scrollbar';
  import 'perfect-scrollbar/css/perfect-scrollbar.css';

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
      new PerfectScrollbar(`.${className}`);
    } else {
      // try to init it later in case this component is loaded async
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }
  import {Google} from 'vue-loading-spinner';
  import DashboardNavbar from './DashboardNavbar.vue';
  import ContentFooter from './ContentFooter.vue';
  import DashboardContent from './Content.vue';
  import { FadeTransition } from 'vue2-transitions';

  export default {
    components: {
      'google-spin': Google,
      DashboardNavbar,
      ContentFooter,
      DashboardContent,
      FadeTransition
    },
    methods: {
      initScrollbar() {
        let isWindows = navigator.platform.startsWith('Win');
        if (isWindows) {
          initScrollbar('scrollbar-inner');
        }
      }
    },
    mounted() {
      this.initScrollbar()
    }
  };
</script>
<style lang="scss">
.spinner.spinner--google{
  z-index: 9999;
  position: fixed;
  right: 2rem;
  bottom: 2rem;
}
</style>
